/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var quickAdd = document.querySelectorAll('[data-variant-add]');

quickAdd.forEach(function(quickAdd) {
  quickAdd.addEventListener('click', function() {
    var variantId = this.getAttribute('data-variant-add');
    var drawerCart = document.querySelector('.js-open-cart');
    
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    
    fetch(window.routes.cartAddUrl + '.js', {
      body: JSON.stringify({ id: variantId, quantity: 1 }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header
      }
    }).then(function (response) {
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
        }));
        setTimeout(function(){ drawerCart.click(); }, 500);
      } else {
        response.json().then(function (content) {
          alert('Error: ' + content['description'])
        });
      }
    });
  });
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var swatchCurrentOption = document.querySelector('[data-current-option]');
  
  swatchCurrentOption.setAttribute('data-current-option', variant.option1);
});

var swatchOptions = document.querySelectorAll('[data-variant-options]');

swatchOptions.forEach(function(swatchOption) {
  swatchOption.addEventListener('click', function(evt) {
    evt.preventDefault();
    
    var sizeOption = document.querySelector('[data-option-name="Size"]:checked').value;
    var sizeOptionIndex = document.querySelector('[data-option-name="Size"]:checked').getAttribute('data-option-index');
    var variantOptions = JSON.parse(this.getAttribute('data-variant-options'));
    var url = Object.values(variantOptions[sizeOptionIndex])[0];
    
    window.location.href = url;
  });
})